import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { Uuid } from 'src/apis/api-utilities';
import type { PriceStepsChangeInfo } from 'src/apis/transport-auction/types';
import type { TransportAuctionServiceRootRequest } from 'src/apis/transport-auction/use-transport-auction-service-root';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

type HookOptions = {
  root: TransportAuctionServiceRootRequest;
  auctionId: Uuid;
};

type ExecuteOptions = {
  url: string;
};

export function usePriceStepsChangeRequest({ root, auctionId }: HookOptions) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) =>
      axios.request<PriceStepsChangeInfo>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!root.response) return;
    if (!root.response.data._links.priceStepsChangeRequest)
      throw new Forbidden();

    const url = urlTemplate
      .parse(root.response.data._links.priceStepsChangeRequest.href)
      .expand({ auctionId });

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [root.response, auctionId]);

  return request;
}

export type PriceStepsChangeInfoRequest = ReturnType<
  typeof usePriceStepsChangeRequest
>;
